import ReactDatePicker from 'react-datepicker';
import CalendarInput from '../../component/CalendarInput';
import 'react-datepicker/dist/react-datepicker.css';
import React from 'react';
import { newYorkMidnight } from '@/utils/helper';

export const DatePicker = ({ label = '', value, handleDateChange }) => {
	return (
		<React.Fragment>
			<b style={{ margin: '0.5rem 0.5rem 0 0' }}>{label}</b>
			<ReactDatePicker
				selected={value}
				dateFormat="MMMM d, yyyy"
				customInput={<CalendarInput />}
				onChange={handleDateChange}
				minDate={newYorkMidnight()}
			/>
		</React.Fragment>
	);
};
